/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import ReactOnRails from "react-on-rails"

// From old Sprockets files
import "../utils/console_log"
import "../utils/page-ready"
import "../utils/affix"
import "../utils/alert-bar"
import "../utils/polyfills"
// import "../utils/mobile-app-banner" //@todo: Re add this
import "../utils/topbar_web" //@todo: Remove this
// end sprockets files

import RequestUserPasswordToken from "../bundles/RequestUserPasswordToken";
import SignInUserLink from "../bundles/SignInUserLink/SignInUserLink";
import NavbarCartItem from "../bundles/NavbarCartItem/NavbarCartItem";
import CartContainer from "../bundles/CartContainer/CartContainer";
import DeliveryModeBox from "../bundles/VenueServicesList/components/DeliveryModeBox";
import VenueServicesList from "../bundles/VenueServicesList/VenueServicesList";
import CartSummaryModal from "../bundles/CartSummaryModal";
import UserSessionForm from "../bundles/UserSessionForm/UserSessionForm";
import CheckoutApp from "../bundles/CheckoutApp/CheckoutApp";
import SearchPlacesForm from "../bundles/SearchPlacesForm/SearchPlacesForm"
import OrderRecap from "../bundles/OrderRecap/index.jsx"
import ShareOrderFacebookButton from "../bundles/SharingButtons/ShareOrderFacebookButton";
import FacebookWallShareButton from "../bundles/SharingButtons/FacebookWallShareButton";
import ShareUrlBox from "../bundles/SharingButtons/ShareUrlBox";
import ChangeUserPasswordApp from "../bundles/ChangeUserPasswordApp";
import SelectAddressPage from "../bundles/SelectAddressPage/SelectAddressPage";
import VenueChooserApp from "../bundles/VenueChooserApp/VenueChooserApp";
import VenueBadges from "../bundles/VenueChooserApp/VenuesList/VenueBox/VenueBadges/index.jsx";
import ChangeAddressForm from "../bundles/ChangeAddressForm"
import PromotionBox from "../bundles/VenueServicesList/components/Details/PromotionBox";
import BottomCartItem from "../bundles/BottomCartItem";
import VenueDescriptionWithShowMore from "../bundles/VenueServicesList/VenueDescriptionWithShowMore"
import PaymentInProgressBanner from "../bundles/PaymentApp/PaymentInProgressBanner"

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  RequestUserPasswordToken,
  ChangeUserPasswordApp,
  SignInUserLink,
  NavbarCartItem,
  BottomCartItem,
  CartContainer,
  DeliveryModeBox,
  VenueServicesList,
  CartSummaryModal,
  UserSessionForm,
  CheckoutApp,
  SearchPlacesForm,
  OrderRecap,
  ChangeAddressForm,
  ShareOrderFacebookButton,
  ShareUrlBox,
  FacebookWallShareButton,
  SelectAddressPage,
  VenueChooserApp,
  VenueBadges,
  PromotionBox,
  VenueDescriptionWithShowMore,
  PaymentInProgressBanner
});
